<template>
	<div class="homePage">
		<!-- 轮播图 -->
		<el-carousel height="500px">
			<el-carousel-item v-for="item in 7" :key="item">
				<el-image :src="'/img/banner/'+item+'.jpg'"  draggable="false" style="height: 500px;"></el-image>
			</el-carousel-item>
		</el-carousel>
		<!-- 基地模块 -->
		<jidi @setDefaultactive='setDefaultactive'></jidi>
		<!-- 已建项目 -->
		<yijian @setDefaultactive='setDefaultactive'></yijian>
		<!-- 在建项目 -->
		<zaijian @setDefaultactive='setDefaultactive'></zaijian>
		<!-- 拟建项目 -->
		<nijian @setDefaultactive='setDefaultactive'></nijian>
		<!-- 荣誉展示 -->
		<rongyu></rongyu>
		<!-- 友情链接-底部信息 -->
		<footer1></footer1>
	</div>
</template>

<script>
	import jidi from './homePage/jidi.vue'
	import yijian from './homePage/project_yijian.vue'
	import zaijian from './homePage/project_zaijian.vue'
	import nijian from './homePage/project_nijian.vue'
	import rongyu from './homePage/rongyu.vue'
	import footer1 from './homePage/footer.vue'

	export default {
		components: {
			jidi,
			yijian,
			zaijian,
			nijian,
			rongyu,
			footer1
		},
		methods: {
			init() {

			},
			setDefaultactive(val) {
				this.$emit('setDefaultactive', val)
			}

		},
		mounted() {
			this.$emit('setDefaultactive')
			//页面加载滚动条 到顶部
			document.querySelector(".el-container").scrollTop = 0
		}
	}
</script>

<style lang="scss">
	.homePage {
		.el-carousel__indicators--horizontal {
			left: 50%;

			li {
				padding: 20px 4px;

				button {
					width: 80px;
					height: 4px;
				}
			}
		}
	}
</style>